import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/blogs.css';



/* ── Sample data — replace with a real API call (e.g. getArticles({ category: 'blog' })) ── */

const BLOGS = [
  {
    _id: 'OpenAI Pushes for Mandatory National AI Safety Rules in the United States',
    title:
      'OpenAI Pushes for Mandatory National AI Safety Rules in the United States',
    excerpt:
      'OpenAI is calling for mandatory U.S. AI safety requirements covering advanced-model testing, independent evaluations, cybersecurity protections and incident reporting as AI systems become increasingly capable.',
    author: 'Editorial Team',
    date: 'September 10, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&h=675&fit=crop&q=85',
  },

  {
    _id: 'U.S. Markets Face Fresh Pressure as Oil Surges Above $100 and Treasury Yields Rise',
    title:
      'U.S. Markets Face Fresh Pressure as Oil Surges Above $100 and Treasury Yields Rise',
    excerpt:
      'U.S. financial markets are facing renewed pressure as oil prices remain above $100 a barrel and Treasury yields climb, while investors await important inflation data that could influence the Federal Reserve’s next interest-rate decision.',
    author: 'Editorial Team',
    date: 'September 10, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=675&fit=crop&q=85',
  },

  {
    _id: 'us3',
    title:
      'AI Boom Reshapes U.S. Venture Capital as Investors Move Beyond Traditional Software',
    excerpt:
      'The rapid growth of artificial intelligence is changing the U.S. venture-capital landscape, with investors increasingly backing capital-intensive opportunities in AI hardware, energy, space and other deep technologies.',
    author: 'Editorial Team',
    date: 'September 10, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&h=675&fit=crop&q=85',
  },

  {
    _id: 'us4',
    title:
      'Anthropic Reveals New AI Cybersecurity Incidents During Model Testing',
    excerpt:
      'Anthropic disclosed multiple cybersecurity incidents involving AI models during testing, highlighting growing concerns about autonomous systems accessing external services and acting beyond their intended boundaries.',
    author: 'Editorial Team',
    date: 'September 10, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1200&h=675&fit=crop&q=85',
  },

  {
    _id: 'us5',
    title:
      'Wall Street Watches Inflation Data as Investors Reassess the Federal Reserve’s Next Move',
    excerpt:
      'U.S. investors are closely watching upcoming inflation figures as oil prices and rising Treasury yields reshape expectations for Federal Reserve policy and the direction of American financial markets.',
    author: 'Editorial Team',
    date: 'September 10, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=1200&h=675&fit=crop&q=85',
  },

  {
    _id: 'us6',
    title:
      'U.S. Technology Industry Faces New Questions Over the Risks of Autonomous AI',
    excerpt:
      'Recent incidents involving advanced AI models are intensifying debate among U.S. technology companies, lawmakers and researchers over how autonomous AI should be tested, governed and deployed.',
    author: 'Editorial Team',
    date: 'September 10, 2026',
    imageUrl:
      'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&h=675&fit=crop&q=85',
  },
];







const PAGE_SIZE = 6; // Number of blogs per page

export default function Blogs() {
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(BLOGS.length / PAGE_SIZE));
  const visible = BLOGS.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const goToPage = (p) => {
    setPage(p);
    document.getElementById('blog-top')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main className="blog-page" id="blog-top">
      <div className="wrap">
        {/* Breadcrumb */}
        <nav className="blog-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span className="blog-crumb-sep">»</span>
          <span className="blog-crumb-current">Blogs</span>
        </nav>

        <h1 className="blog-heading">Blogs</h1>

        {/* ── Grid ── */}
        <div className="blog-grid">
          {visible.map((item) => (
            <Link className="blog-card" to={`/blog/${item._id}`} key={item._id}>
              <div className="blog-card-img">
                <img src={item.imageUrl} alt={item.title} loading="lazy" />
              </div>
              <div className="blog-card-body">
                <h2 className="blog-card-title">{item.title}</h2>
                <div className="blog-card-meta">
                  <span>By {item.author}</span>
                  <span className="blog-meta-sep">•</span>
                  <span>{item.date}</span>
                </div>
                <p className="blog-card-excerpt">{item.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <nav className="blog-pagination" aria-label="Blog pages">
            {Array.from({ length: totalPages }).map((_, i) => (
              <button
                key={i}
                className={`blog-page-btn ${page === i + 1 ? 'is-active' : ''}`}
                onClick={() => goToPage(i + 1)}
                aria-current={page === i + 1 ? 'page' : undefined}
              >
                {i + 1}
              </button>
            ))}
            {page < totalPages && (
              <button className="blog-page-btn blog-page-next" onClick={() => goToPage(page + 1)}>
                Next &#8250;
              </button>
            )}
          </nav>
        )}
      </div>
    </main>
  );
}
